var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c('SkeletonLoader',{attrs:{"show-animation":"","data-testid":"pagination-loading"}},[_c('div',{staticClass:"trade-pagination--loading"})]):_c('Pagination',{attrs:{"data-testid":"pagination","total-pages":_vm.totalPages,"current-page":_vm.currentPage},on:{"page-changed":_vm.handlePageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }